import {ApolloError} from '@apollo/client'
import {useCallback} from 'react'
import {useGLTranslation} from 'notability-services-common-frontend'

export function useTranslateApolloError() {
  const {t} = useGLTranslation()
  const networkErrorMessage = t('serverConnectionErrorMessage')
  const translateError = useCallback(
    (apolloError: ApolloError) => {
      const errorMessages = []
      if (apolloError.networkError) {
        // Should only receive network errors when failing to reach server or making bad requests
        errorMessages.push(networkErrorMessage)
      }

      if (apolloError.graphQLErrors?.length ?? 0 > 0) {
        apolloError.graphQLErrors.forEach((e) => errorMessages.push(e.message))
      }

      if (errorMessages.length > 0) {
        return errorMessages
      } else {
        return [apolloError.message]
      }
    },
    [networkErrorMessage]
  )

  return translateError
}
